import {
	assoc,
	equals, filter,
	findIndex,
	keys,
	length,
	map, pathEq,
	pick,
	pipe, prop,
	propEq, reduce,
	sort,
	update,
} from 'ramda';
import {
	addUuidName, addWeighWith, diff,
	generateWeighingComparison,
} from '@/modules/job-evaluation/utils/valuation-model/factors';
import { parseRequestValuation } from '@/modules/job-evaluation/utils/valuation-model/degree';
import Vue from 'vue';

const findIndexFactor = (factor, factorList) => findIndex(propEq('uuid', factor.uuid), factorList);

export default {
	resetValuationModelState({ commit }) {
		commit('RESET_VALUATION_MODEL');
	},
	updateSelectedFactors({ commit }, selectedFactors) {
		const combinations = generateWeighingComparison(selectedFactors);
		commit('UPDATE_COMBINATIONS', combinations);
		commit('UPDATE_SELECTED_FACTORS', addWeighWith(selectedFactors, combinations));
	},
	setSelectedFactors({ commit }, selectedFactors) {
		commit('UPDATE_SELECTED_FACTORS', selectedFactors);
	},
	setCombinations({ commit }, combinations) {
		commit('UPDATE_COMBINATIONS', combinations);
	},
	setFactorDegrees({ commit }, factorDegrees) {
		commit('SET_FACTOR_DEGREES', factorDegrees);
	},
	updateSelectedFactor({ commit }, selectedFactor) {
		commit('UPDATE_SELECTED_FACTOR', selectedFactor);
	},
	updateSelectedFactorDegree({ commit }, selectedFactor) {
		commit('UPDATE_SELECTED_FACTOR_DEGREE', selectedFactor);
	},
	updateFactorInSelectedFactors({ state, commit }, itemToReplace) {
		const selectedFactors = state.supplies.valuationModel.selectedFactors;
		const indexFound = findIndexFactor(itemToReplace, selectedFactors);
		commit('UPDATE_SELECTED_FACTORS', update(indexFound, itemToReplace, selectedFactors));
	},
	async getFactors({ state, commit }) {
		if (length(state.supplies.valuationModel.factorList) < 1) {
			const { data: factors } = await Vue.prototype.$http.get('/hierarchies/JEV?flagLevel=true&level=3');
			commit('UPDATE_FACTORS', map(addUuidName, factors));
		}
	},
	updateCombination({ commit, state }, newCombination) {
		const currentCombinations = state.supplies.valuationModel.weighing.combinations;
		const sortKeys = combinationItem => sort(diff, keys(combinationItem));
		const indexFound = findIndex(
			combinationItem => equals(sortKeys(newCombination), sortKeys(combinationItem)),
			currentCombinations,
		);
		commit('UPDATE_COMBINATIONS', update(indexFound, newCombination, currentCombinations));
	},
	updateCombinations({ commit }, newCombinations) {
		commit('UPDATE_COMBINATIONS', newCombinations);
	},
	async getDegrees({ commit, state }) {
		const { selectedFactors = [] } = state.supplies.valuationModel;
		try {
			const { data: degrees } = await Vue.prototype.$http.get('/hierarchies/JEV?flagLevel=true&level=4');
			const degreesByFactors = reduce(
				(acc, factor) => assoc(
					prop('uuid', factor),
					pipe(
						filter(pathEq(['kindEntity', 'code'], prop('code', factor))),
						map(pipe(addUuidName, pick(['uuid', 'name', 'code']))),
					)(degrees),
					acc,
				),
				{},
				selectedFactors,
			);
			commit('UPDATE_DEGREES_BY_FACTOR', degreesByFactors);
			return true;
		} catch (e) {
			throw e;
		}
	},
	updateFactorDegrees({ commit }, factorDegrees) {
		commit('UPDATE_FACTOR_DEGREES', factorDegrees);
	},
	async createValuation({ state }) {
		const payloadRequest = parseRequestValuation(state);
		try {
			await Vue.prototype.$http.post('/polls', payloadRequest);
			return true;
		} catch (e) {
			throw e;
		}
	},
	async savePayrollProposal(_, payload) {
		const { currentPayroll, idealPayroll } = payload;
		try {
			await Vue.prototype.$http.patch('/polls/JEV', {
				additionalInformation: {
					currentPayroll: parseFloat(currentPayroll),
					idealPayroll: parseFloat(idealPayroll),
				},
				stageStatus: 2,
				stageDetailStatus: 1,
			});
			return true;
		} catch (e) {
			throw e;
		}
	},
};



// WEBPACK FOOTER //
// ./src/modules/job-evaluation/store/valuation-model/actions.js